import PropTypes from 'prop-types';
import { Container, Stack } from '@mui/material';
import { HeaderSimple as Header } from '../_common';

// ----------------------------------------------------------------------

export default function SimpleLayout({ children }) {
  return (
    <>
      <Header />

      <Container component="main">
        <Stack
          sx={{
            py: 12,
            minHeight: '100vh',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}

SimpleLayout.propTypes = {
  children: PropTypes.node,
};
